(function () {
  'use strict';

  var money = function (cents) {
    return (cents / 100).toLocaleString('de-DE', {
      style: 'currency', currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'EUR'
    });
  };

  // --- Mobile menu ---------------------------------------------------------
  var toggle = document.querySelector('[data-menu-toggle]');
  var menu = document.querySelector('[data-mobile-menu]');
  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      var open = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // --- Cart drawer ---------------------------------------------------------
  var drawer = document.querySelector('[data-cart-drawer]');
  var scrim = document.querySelector('[data-cart-scrim]');
  var body = document.querySelector('[data-cart-body]');
  var totalEl = document.querySelector('[data-cart-total]');
  var countEl = document.querySelector('[data-cart-count]');
  var lastFocus = null;

  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    if (scrim) { scrim.hidden = false; requestAnimationFrame(function () { scrim.classList.add('is-open'); }); }
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    var close = drawer.querySelector('[data-cart-close]');
    if (close) close.focus();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (scrim) {
      scrim.classList.remove('is-open');
      setTimeout(function () { scrim.hidden = true; }, 350);
    }
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function renderCart(cart) {
    if (countEl) {
      countEl.textContent = cart.item_count;
      countEl.classList.add('is-bumped');
      setTimeout(function () { countEl.classList.remove('is-bumped'); }, 300);
    }
    if (totalEl) totalEl.textContent = money(cart.total_price);
    if (!body) return;

    if (!cart.items.length) {
      body.innerHTML = '<div class="drawer__empty"><span>noch leer</span><p class="eyebrow">Alles Einzelstücke</p></div>';
      return;
    }

    body.innerHTML = cart.items.map(function (item) {
      var img = item.image
        ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') + '" alt="" loading="lazy">'
        : '';
      var variant = item.variant_title && item.variant_title !== 'Default Title'
        ? '<div class="cart-item__variant">' + item.variant_title + '</div>'
        : '';
      return '<div class="cart-item">' +
        '<div class="cart-item__image">' + img + '</div>' +
        '<div>' +
          '<h4 class="cart-item__title"><a href="' + item.url + '">' + item.product_title + '</a></h4>' +
          variant +
          '<button class="cart-item__remove" type="button" data-cart-remove="' + item.key + '">Entfernen</button>' +
        '</div>' +
        '<div class="cart-item__total">' + money(item.final_line_price) + '</div>' +
      '</div>';
    }).join('');
  }

  function fetchCart(open) {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCart(cart);
        if (open) openDrawer();
      })
      .catch(function () { /* Netzwerkfehler: Lade bleibt wie sie ist */ });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); fetchCart(true); }
    if (e.target.closest('[data-cart-close]')) closeDrawer();
    if (scrim && e.target === scrim) closeDrawer();

    var remove = e.target.closest('[data-cart-remove]');
    if (remove) {
      e.preventDefault();
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: remove.getAttribute('data-cart-remove'), quantity: 0 })
      })
        .then(function (r) { return r.json(); })
        .then(renderCart);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  if (drawer) fetchCart(false);

  // --- In die Tasche, ohne Seitenwechsel -----------------------------------
  document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var button = form.querySelector('[data-add-button]');
      if (!button || button.disabled) return;
      e.preventDefault();

      button.classList.add('is-loading');
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () {
          button.classList.remove('is-loading');
          var original = button.textContent;
          button.classList.add('is-added');
          button.textContent = 'Hinzugefügt';
          setTimeout(function () {
            button.classList.remove('is-added');
            button.textContent = original;
          }, 1600);
          return fetchCart(true);
        })
        .catch(function () {
          // Wenn AJAX scheitert, normal abschicken statt stillschweigend nichts tun
          button.classList.remove('is-loading');
          form.submit();
        });
    });
  });

  // --- Product variant selection ------------------------------------------
  document.querySelectorAll('[data-variant-select]').forEach(function (select) {
    var form = select.closest('form');
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    var button = form.querySelector('[data-add-button]');
    var priceEl = document.querySelector('[data-product-price]');
    var variants = {};
    try {
      variants = JSON.parse(document.querySelector('[data-variant-data]').textContent);
    } catch (e) { /* no variant data — fall back to server-rendered state */ }

    select.addEventListener('change', function () {
      var variant = variants[select.value];
      if (idInput) idInput.value = select.value;
      if (!variant) return;
      if (priceEl && variant.price_html) priceEl.innerHTML = variant.price_html;
      if (button) {
        button.disabled = !variant.available;
        button.textContent = variant.available ? button.dataset.textAvailable : button.dataset.textSoldOut;
      }
    });
  });

  // --- Cart quantity auto-submit ------------------------------------------
  document.querySelectorAll('[data-cart-quantity]').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.closest('form');
      if (form) form.submit();
    });
  });

  // --- Collection sort auto-submit ----------------------------------------
  var sort = document.querySelector('[data-sort-select]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }
})();
